import { CategoryObject } from 'src/app/components/TableComponent/MediaInsightTableComponent/media-insight-table.config';
import { EditBlockDataType } from 'src/app/redux/block/block-slice.type';
import { InterestClassType, InterestsTypes } from 'src/enums/interests.enum';
import { BlockStatisticStatus } from 'src/enums/surfer.enums';

export const getSentimentAnalysisStatus = (analysis: 'positive' | 'neutral' | 'negative'): BlockStatisticStatus => {
  switch (analysis) {
    case 'negative':
      return BlockStatisticStatus.NEGATIVE;

    case 'positive':
      return BlockStatisticStatus.POSITIVE;
    case 'neutral':
      return BlockStatisticStatus.NEUTRAL;
    default:
      return BlockStatisticStatus.NEUTRAL;
  }
};

export const convertInterestListToBlockEditData = (
  interestList: {
    type: InterestsTypes;
    classEnum: InterestClassType;
    interestId: CategoryObject[];
  }[],
): { [key: string]: EditBlockDataType[number] } => {
  const result: { [key: string]: EditBlockDataType[number] } = {};
  interestList.forEach((obj) => {
    if (Number(obj.classEnum) === InterestClassType.Identified) {
      obj.interestId.forEach((int) => {
        result[int.id] = { id: int.id, interestClassType: Number(obj.classEnum), type: obj.type };
      });
    }
  });
  return result;
};
